export default __webpack_public_path__ + "static/media/link-icon.c8e82e39.svg";